const queryStringHelper = {
  setParam: (key: string, value: string) => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(key) === value) return;

    params.set(key, value);
    window.history.replaceState({}, "", `?${params.toString()}`);
  },
  getParam: (key: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  },
};

export default queryStringHelper;
